export type CareersLang = "de" | "en";

/** Main careers overview path for the given language. EN has a dedicated shareable URL. */
export function careersHomeHref(lang: CareersLang): string {
  return lang === "en" ? "/careers/en" : "/careers";
}

/** Engineering page is English-only — one URL, no DE/EN pair. */
export function careersEngineeringHref(): string {
  return "/careers/engineering";
}

/** Developer apply page is English-only — one URL, no DE/EN pair. */
export function careersDevelopersHref(): string {
  return "/careers/developers";
}

/** Jobs-section anchor on the main careers page for the given language. */
export function careersJobsAnchorHref(lang: CareersLang): string {
  return `${careersHomeHref(lang)}#jobs`;
}

/**
 * Maps a careers pathname to the equivalent path in the other language.
 * DE lives at `/careers…`; EN at `/careers/en…`.
 */
export function careersTogglePath(pathname: string): string {
  if (
    pathname === "/careers/engineering" ||
    pathname === "/careers/en/engineering"
  ) {
    return "/careers/engineering";
  }
  if (
    pathname === "/careers/developers" ||
    pathname === "/careers/en/developers" ||
    pathname.startsWith("/careers/developers/")
  ) {
    return "/careers/developers";
  }
  if (pathname === "/careers/en" || pathname.startsWith("/careers/en/")) {
    return pathname.replace("/careers/en", "/careers");
  }
  if (pathname === "/careers" || pathname.startsWith("/careers/")) {
    return pathname.replace("/careers", "/careers/en");
  }
  return "/careers/en";
}
